import { apiClient } from './api';

export const companyService = {
  // Get company profile (public)
  getProfile: async () => {
    return await apiClient.get('/company/profile');
  },

  // Update company profile (admin only)
  updateProfile: async (profileData) => {
    const formData = new FormData();
    
    Object.keys(profileData).forEach(key => {
      if (key !== 'ceo_avatar') {
        if (typeof profileData[key] === 'object' && profileData[key] !== null) {
          formData.append(key, JSON.stringify(profileData[key]));
        } else {
          formData.append(key, profileData[key]);
        }
      }
    });

    if (profileData.ceo_avatar) {
      formData.append('ceo_avatar', profileData.ceo_avatar);
    }

    return await apiClient.upload('/company/profile', formData);
  },

  // Get CEO information (public)
  getCEOInfo: async () => {
    return await apiClient.get('/company/ceo');
  },

  // Update CEO information (admin only)
  updateCEOInfo: async (ceoData) => {
    const formData = new FormData();
    
    Object.keys(ceoData).forEach(key => {
      if (key !== 'ceo_avatar') {
        formData.append(key, ceoData[key]);
      }
    });

    if (ceoData.ceo_avatar) {
      formData.append('ceo_avatar', ceoData.ceo_avatar);
    }

    return await apiClient.upload('/company/ceo', formData);
  },

  // Get contact information (public)
  getContactInfo: async () => {
    return await apiClient.get('/company/contact');
  },

  // Update contact information (admin only)
  updateContactInfo: async (contactData) => {
    return await apiClient.put('/company/contact', contactData);
  },

  // Get company statistics (public)
  getStatistics: async () => {
    return await apiClient.get('/company/statistics');
  },

  // Get company history (public)
  getHistory: async () => {
    return await apiClient.get('/company/history');
  },

  // Update company history (admin only)
  updateHistory: async (historyData) => {
    return await apiClient.put('/company/history', historyData);
  },
};

// Named exports untuk backward compatibility dengan companyAPI
export const companyAPI = {
  getProfile: companyService.getProfile,
  updateProfile: companyService.updateProfile,
  getCEOInfo: companyService.getCEOInfo,
  updateCEOInfo: companyService.updateCEOInfo,
  getContactInfo: companyService.getContactInfo,
  updateContactInfo: companyService.updateContactInfo,
  getStatistics: companyService.getStatistics,
  getHistory: companyService.getHistory,
  updateHistory: companyService.updateHistory,
};

// Individual named exports
export const getProfile = companyService.getProfile;
export const updateProfile = companyService.updateProfile;
export const getCEOInfo = companyService.getCEOInfo;
export const updateCEOInfo = companyService.updateCEOInfo;
export const getContactInfo = companyService.getContactInfo;
export const updateContactInfo = companyService.updateContactInfo;
export const getStatistics = companyService.getStatistics;
export const getHistory = companyService.getHistory;
export const updateHistory = companyService.updateHistory;